WL.registerComponent('set-friction', {
    staticFriciton: {type: WL.Type.Float, default: 1.0},
    dynamicFriction: {type: WL.Type.Float, default: 1.0}
}, {
    init: function() {
      this.body = this.object.getComponent('physx');
      this.body.staticFriction = this.staticFriction;
      this.body.dynamicFriction = this.dynamicFriction;
    }
});
